module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "audit-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-audit-dup",
      modifiers: {
        "confirm-audit-dup": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          Duplicate\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveAudit()
      }
    }
  }, [_vm._v("\n          Save\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-audit-del",
      modifiers: {
        "confirm-audit-del": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          Delete whole audit\n        ")])], 1)]), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-audit-dup",
      "title": "Duplicate Audit",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.duplicateAudit(true)
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("This action will duplicate the entire content of this audit."), _c('br'), _vm._v("Do you want to proceed?")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-audit-del",
      "title": "Delete Audit",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.deleteAudit()
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Are you sure you want to delete the whole audit")])]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-wrapper"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-7",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.name ? '' : 'Enter audit title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "picture_url", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.role) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(3), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row separator mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.areaFromList = !_vm.areaFromList
      }
    }
  }, [_vm._v("Or select from list\n          ")])], 1), _vm._v(" "), (_vm.areaFromList) ? _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "radio",
      "areas": _vm.areas,
      "baseId": 'areaCheckbox',
      "selected": _vm.formData.area
    },
    on: {
      "selectedAreaChanged": function($event) {}
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.area.length) ? 'has-danger' : '', 'line']
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.formData.area), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "options": _vm.signatureCountOptions
    },
    model: {
      value: (_vm.formData.signatureCount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "signatureCount", $$v)
      },
      expression: "formData.signatureCount"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "disabled": _vm.is_performed,
      "options": _vm.scoreTypeOptions
    },
    model: {
      value: (_vm.formData.score_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "score_type", $$v)
      },
      expression: "formData.score_type"
    }
  }), _vm._v(" "), (_vm.is_performed) ? _c('span', [_vm._v("Once an audit has been executed, the scoring system can no longer be changed.")]) : _vm._e(), _vm._v(" "), (_vm.formData.score_type == 'score') ? _c('div', {
    staticClass: "row score-point"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowScore),
      expression: "formData.lowScore"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "name": "lowScore",
      "type": "number",
      "min": "0",
      "max": _vm.formData.highScore - 1,
      "step": "1",
      "disabled": _vm.is_performed
    },
    domProps: {
      "value": (_vm.formData.lowScore)
    },
    on: {
      "change": function($event) {
        return _vm.onScoreChange($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowScore", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.highScore),
      expression: "formData.highScore"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "name": "highScore",
      "type": "number",
      "min": +_vm.formData.lowScore + 1,
      "max": "10",
      "step": "1",
      "disabled": _vm.is_performed
    },
    domProps: {
      "value": (_vm.formData.highScore)
    },
    on: {
      "change": function($event) {
        return _vm.onScoreChange($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "highScore", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.formData.id) ? _c('b-button', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveAudit()
      }
    }
  }, [_vm._v("\n        Save and continue\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-3",
    on: {
      "click": function($event) {
        _vm.showTasks = !_vm.showTasks
      }
    }
  }, [_c('b', [_vm._v("Audit questions")])])]) : _vm._e(), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "questions-wrapper",
    attrs: {
      "id": "collapse-audits"
    }
  }, [_c('b-list-group', [(!_vm.formData.tasks.length) ? _c('b-list-group-item', {
    staticClass: "list-group-question"
  }, [_vm._v("\n              There are no questions in this audit yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('b-list-group-item', {
      key: index,
      staticClass: "list-group-question draggable",
      attrs: {
        "active": index === _vm.activeTask,
        "draggable": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.activeTaskNext = index
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.addEmptyTask
    }
  }, [_vm._v("+ Add one more question")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTask === index),
        expression: "activeTask === index"
      }],
      staticClass: "question-wrapper"
    }, [_c('h2', [_vm._v("Audit question information")]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.name) ? 'has-danger' : '', 'row basic-info__title']
    }, [_vm._m(10, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "col-md-9 form-control",
      attrs: {
        "type": "text",
        "placeholder": "Enter question title",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '', 'row']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "col-md-10 basic-info__description form-control",
      attrs: {
        "placeholder": "Enter description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 "
    }, [_c('p', {
      staticClass: "col-md-3"
    }, [_c('b', [_vm._v("Upload "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("image")]), _vm._v("\n            or\n            "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")]), _vm._v(" for this question")]), _vm._v(" (if none, default icon will be used)")]), _vm._v(" "), (item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.picture_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "picture_url", $event)
        },
        "change": function($event) {
          return _vm.onChangeAuditTask()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.selectedContent == 'video'),
        expression: "item.selectedContent == 'video'"
      }],
      class: [(item.video_require) ? 'has-danger' : ''],
      attrs: {
        "id": ""
      }
    }, [_c('div', {
      class: [(item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.thumbnail_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "thumbnail_url", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "auditItemVideoFile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearAuditItemVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 align-items-center"
    }, [_vm._m(12, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('b-form-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "number"
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        }
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 align-items-center",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_c('multiselect', {
      attrs: {
        "tag-placeholder": "Add this as new tag",
        "placeholder": "Search or add a tag",
        "label": "name",
        "track-by": "code",
        "options": _vm.tagsOptions,
        "multiple": true,
        "taggable": true
      },
      on: {
        "tag": function (tag) { return _vm.addTag(item, tag); },
        "input": function (tag) { return _vm.updateTags(item, tag); }
      },
      model: {
        value: (item.tagsValue),
        callback: function($$v) {
          _vm.$set(item, "tagsValue", $$v)
        },
        expression: "item.tagsValue"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "instructions"
    }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this question. If left blank no instructions for this question will be shown.")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('b-form-file', {
      ref: 'pdffile' + index,
      refInFor: true,
      attrs: {
        "placeholder": item.description_file_url,
        "choose-label": (!item.description_file && !item.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
        "accept": ".pdf"
      },
      nativeOn: {
        "click": function($event) {
          _vm.clearPdfFile($event, index);
          (item.description_file) ? _vm.onChangeAuditTask(): '';
        },
        "change": function($event) {
          _vm.onChangeAuditTask();
          _vm.changePdfFile($event, index);
        }
      },
      model: {
        value: (item.description_file),
        callback: function($$v) {
          _vm.$set(item, "description_file", $$v)
        },
        expression: "item.description_file"
      }
    })], 1)]), _vm._v(" "), (!item.steps.length) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!item.description_file && !item.description_file_url)),
        expression: "(!item.description_file && !item.description_file_url)"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addEmptyStep(item);
          _vm.onChangeAuditTask()
        }
      }
    }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((item.steps), function(step, index) {
      return [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((!item.description_file && !item.description_file_url)),
          expression: "(!item.description_file && !item.description_file_url)"
        }],
        staticClass: "instructions__step"
      }, [_c('div', {
        staticClass: "row align-items-baseline"
      }, [_vm._m(15, true), _vm._v(" "), _vm._m(16, true), _vm._v(" "), _c('div', {
        class: [(!step.valid) ? 'has-danger' : '', 'col-md-1']
      }, [_c('b-form-input', {
        staticStyle: {
          "width": "55px"
        },
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            _vm.validateSteps(item);
            _vm.onChangeAuditTask();
          }
        },
        model: {
          value: (step.order),
          callback: function($$v) {
            _vm.$set(step, "order", $$v)
          },
          expression: "step.order"
        }
      })], 1), _vm._v(" "), _c('p', {
        staticClass: "col-md-5 offset-md-3"
      }, [_c('b', [_vm._v("Attach\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'image'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'image'
          }
        }
      }, [_vm._v("photo")]), _vm._v("\n                    or\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'video'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'video'
          }
        }
      }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [(!step.valid) ? _c('div', {
        staticClass: "col-md-5 offset-md-3",
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                    Please enter a number that is not used\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-7"
      }, [_c('span', {
        class: [(_vm.needFill && !step.description) ? 'has-danger' : '']
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (step.description),
          expression: "step.description"
        }],
        staticClass: " instructions__step-text form-control",
        attrs: {
          "placeholder": "Enter step description"
        },
        domProps: {
          "value": (step.description)
        },
        on: {
          "change": function($event) {
            return _vm.onChangeAuditTask()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(step, "description", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "instructions__step-buttons"
      }, [(index == item.steps.length - 1) ? _c('b-button', {
        attrs: {
          "variant": "primary"
        },
        on: {
          "click": function($event) {
            _vm.addEmptyStep(item);
            _vm.onChangeAuditTask()
          }
        }
      }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != item.steps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (item.steps.length) ? _c('b-button', {
        attrs: {
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeStep(item, index);
            _vm.onChangeAuditTask()
          }
        }
      }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [(step.selectedContent == 'image') ? _c('thumbnail', {
        attrs: {
          "picture": step.picture,
          "picture_url": step.picture_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "picture", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "picture_url", $event)
          },
          "change": function($event) {
            return _vm.onChangeAuditTask()
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (step.selectedContent == 'video'),
          expression: "step.selectedContent == 'video'"
        }],
        class: [(step.video_require) ? 'has-danger' : ''],
        attrs: {
          "id": ""
        }
      }, [_c('div', {
        staticClass: "row ",
        class: [(step.video_require) ? 'form-control' : '']
      }, [_c('thumbnail', {
        attrs: {
          "picture": step.video_thumbnail,
          "picture_url": step.thumbnail_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "video_thumbnail", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "thumbnail_url", $event)
          }
        }
      }), _vm._v(" "), _c('b-form-file', {
        ref: "stepvideofile",
        refInFor: true,
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "accept": ".mp4, .mov",
          "choose-label": (!step.video && !step.video_url) ? 'Choose video' : 'Remove video',
          "placeholder": step.video_url
        },
        on: {
          "change": function($event) {
            return _vm.handleVideoFileChange($event)
          }
        },
        nativeOn: {
          "click": function($event) {
            return _vm.clearStepVideo($event, step, index)
          }
        },
        model: {
          value: (step.video),
          callback: function($$v) {
            _vm.$set(step, "video", $$v)
          },
          expression: "step.video"
        }
      })], 1)])], 1)])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          return _vm.saveTask(item)
        }
      }
    }, [_vm._v("Save this question")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTask(item, index)
        }
      }
    }, [_vm._v("Delete this question")])], 1)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "leavingItemConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n      You have unsaved changes in this item. You want to:\n      "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveTask(_vm.formData.tasks[_vm.activeTask]);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.discardTaskChanges(_vm.activeTask);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.leavingItemConfirm.hide();
        _vm.activeTaskNext = null;
      }
    }
  }, [_vm._v("Return to this item")])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Audit title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Upload main audit image")]), _vm._v(" (if none, default icon will be used)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("The audit needs to be sign at the end?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Audit score type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-point__text"
  }, [_c('b', [_vm._v("Lowest point")]), _c('br'), _vm._v("enter a digit min 0\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-point__text"
  }, [_c('b', [_vm._v("Highest  point")]), _c('br'), _vm._v("enter a digit higher than lowest max 10\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2 mt-1"
  }, [_c('b', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Question weight")]), _vm._v(" (enter a multiplier for this question score. If nothing entered use 1 as default)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Tags")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b84a1e1","hasScoped":true}!./src/components/auditConfig/auditConfig.component.html
// module id = 545
// module chunks = 1